export default __webpack_public_path__ + "static/media/Slide17.a1506a7a.jpg";